const newsletterNewStyles = `
  /* Host custom properties */
  :host {
    --heading-text-color: #F9F9EE;
    --inline-container-max-width: unset;
  }

  /* Container */
  ._formContainer_whyqz_30 ._gridItem_whyqz_169 {
    display: flex;
    flex-direction: column;
    gap: 20px;
    justify-content: center;
    align-items: center;
  }
  ._formFieldContainer_f5ghm_5:focus-within ._formInputFieldLabel_f5ghm_37 {
    transform: translateY(-100%)!important;
    font-size: 7px;

  }
  ._formFieldContainer_f5ghm_5:focus-within ._formInputFieldLabel_f5ghm_37{
    width:auto!important;
  }
  ._formFieldContainer_f5ghm_5 ._inputFilled_f5ghm_76 {
    transform: translateY(-100%) !important;
    font-size: 7px !important;
  }
  ._inline_whyqz_45 ._formContainer_whyqz_30 {
    min-height: auto !important ;
  }
  ._formContainer_whyqz_30 ._formInputFieldLabel_f5ghm_37 {
    color: #f9f9ee;
  font-family: "Epilogue", sans-serif;
  font-weight: 500;
    font-size: 16px;
    line-height: 23.02px;
    top: 50%;
    transform: translateY(-50%);
}
  @media screen and (min-width: 1114px) {
    ._inline_whyqz_45 ._formContainer_whyqz_30{
      width: 791px !important;
    }
    ._formContainer_whyqz_30 ._textHeading_2aowh_35 {
      min-width: 382px;
    }
  }
  @media (min-width: 992px) {
    ._formContainer_whyqz_30 ._gridItem_whyqz_169 {
      flex-direction: row;
    }
  }

  /* Heading wrapper */
  ._formContainer_whyqz_30 ._formHeader_1ll8d_19 {
    margin: 0;
  }

  /* Heading */
  ._formContainer_whyqz_30 ._textHeading_2aowh_35 {
    font-family: TAYTommyTokyo;
    font-size: 32px;
    line-height: 32px;
    font-weight: 400;
  }

  /* Input + Button container */
  ._formContainer_whyqz_30 ._formFieldset_1ll8d_67 {
    flex-direction: row;
  }
  input._formInputField_237zm_7:focus-visible {
    border: 1px solid #f9f9ee!important;
    outline:none!important;
    box-shadow:none!important;
  }
  @media screen and (max-width: 425px){
    ._formContainer_whyqz_30 ._formInputField_237zm_7 {
      max-width: 257px !important;
    }
  }
  @media screen and (max-width: 320px){
    ._formContainer_whyqz_30 ._formInputField_237zm_7 {
      max-width: 170px !important;
    }
  }

  /* Form */
  ._formContainer_whyqz_30 ._formFieldset_1ll8d_67,
  ._formContainer_whyqz_30 ._formFieldset_1ll8d_67 > div {
    position: relative;
    width: calc(100% - 2em);
  }

  /* Input */
  ._formContainer_whyqz_30 ._formInputField_237zm_7 {
    box-sizing: border-box;
    max-width: 290px;
    width:100%;
    flex-grow: 1;
    padding: 1.5rem;
    text-align: left;
    background: transparent;
    border: 1px solid #f9f9ee;
    color: #f9f9ee;
    height: 45px;
    transition: box-shadow .1s ease;
    border-radius: 0;
  }

  /* Label */
  ._formContainer_whyqz_30 ._formInputFieldLabel_f5ghm_37 {
    color: #f9f9ee;
    font-family: "Epilogue", sans-serif;
    font-weight: 500;
    font-size: 16px;
    line-height: 23.02px;
    top: 50%;
    transform: translateY(-50%);
  }

  /* Button */
  ._formContainer_whyqz_30 ._formSubmitButton_1ll8d_81 {
    box-sizing: border-box;
    position: absolute;
    right: 18px;
    top: 0;
    z-index: 2;
    padding: 0;
    height: 100%;
    display: grid;
    place-items: center;
   font-family: "Epilogue", sans-serif;
    font-size: 14px;
    font-weight: 700;
    line-height: 23.02px;
    text-align: center;
    color: #010101;
    max-width: 100px;
    width: 100%;
    background-color: #f9f9ee;
    border-radius: 65px;
    transition: .4s ease-in-out;
  }
  button._formSubmitButton_1ll8d_81:focus-visible, button._formSubmitButton_1ll8d_81:hover{
    background-color: #010101 !important;
    border: 2px solid #f9f9ee !important;
    color: white;
    filter: none !important;
    box-shadow:none;
  }
  /* thanks success */
  ._textBody_2aowh_10, span._textBody_2aowh_10, p._textBody_2aowh_10{
    color:white!important;
    font-family: "Epilogue", sans-serif !important;
    font-weight: 500;
    font-size: 16px!important;
  }

  @media (min-width: 520px) {
    ._formContainer_whyqz_30 ._formSubmitButton_1ll8d_81 {
      max-width: 157px;
      font-size: 16px;
      right: 20px;
    }
  }
`

function injectStyles() {
  const host = document.querySelector("form-embed#app-embed");

  if (host) {
    const newsletterStyles = document.createElement("style");
    newsletterStyles.innerHTML = newsletterNewStyles;

    host.shadowRoot.appendChild(newsletterStyles);
  } else {
    setTimeout(injectStyles, 1000);
  }
}

document.addEventListener("DOMContentLoaded", function () {
  injectStyles();

  setTimeout(() => {
    clearTimeout(injectStyles);
  }, 60000);
});





